import { render } from "./FRView.vue?vue&type=template&id=b215c516"
import script from "./FRView.vue?vue&type=script&lang=js"
export * from "./FRView.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__